export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/60 via-background-50 to-background-100/40 pointer-events-none"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5 whitespace-nowrap">
              免费电视剧大全 · 热播剧完整版
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3">
              被窝影院
              <br />
              <span className="text-primary-600">窝在被窝里的追剧天堂</span>
            </h1>

            <p className="text-sm md:text-base text-accent-600 font-medium mb-5">
              每晚八点，打开被窝影院，开启属于你的追剧时光
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              被窝影院为你打造最舒适的在线追剧体验。全网热门免费电视剧大全一站收录，最新电视剧免费在线观看，热播剧完整版高清流畅不缓冲。
              从古装大剧到都市情感，从悬疑刑侦到科幻巨制，国产剧免费观看资源每日更新，让你窝在被窝里畅享追剧时光。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mb-8">
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">每日更新 50+集</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">收录 5,000+ 剧集</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">99% 高清覆盖</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm no-underline"
              >
                <i className="ri-fire-line"></i>
                查看热播榜单
              </a>
              <a
                href="#carousel"
                onClick={(e) => handleScroll(e, '#carousel')}
                className="inline-flex items-center gap-2 px-8 py-3 border border-foreground-200 text-foreground-700 hover:bg-background-100 font-medium rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm no-underline"
              >
                <i className="ri-compass-3-line"></i>
                探索热门专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-[540px]">
              <div className="absolute -inset-4 bg-primary-100/60 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20bedroom%20at%20night%20with%20a%20person%20wrapped%20in%20soft%20blanket%20watching%20a%20large%20TV%20screen%20showing%20colorful%20cinematic%20scenes%2C%20warm%20ambient%20lighting%20from%20a%20bedside%20lamp%2C%20soft%20pillows%20and%20blankets%2C%20comfortable%20home%20cinema%20atmosphere%2C%20minimalist%20modern%20interior%20with%20wooden%20elements%2C%20evening%20mood%2C%20warm%20golden%20and%20amber%20tones%2C%20cinematic%20composition%2C%20cozy%20vibes&width=1080&height=720&seq=hero-main-visual&orientation=landscape"
                alt="被窝影院 - 窝在被窝里享受高清流畅追剧体验"
                title="被窝影院 - 窝在被窝里享受高清流畅追剧体验"
                className="relative z-10 w-full h-auto rounded-2xl object-cover shadow-lg"
                width="1080"
                height="720"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}